import services from 'services/services';
import * as types from '../types';
import { setRequestUrl } from 'store/actions';

// Import helpers
import {
	checkFetchErrors,
	queryParams
} from '../helpers_actions/convert_helpers';

// Import variables
import { TABLE_LENGTH } from 'components/helpers/table';

// ******************** FETCH ACTIVITIES OF OPERATOR- TABLE DATA ********************
export const fetchActivitiesOperator = (options) => async (
	dispatch,
	getState
) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_ACTIVITIES_OPERATOR_LOADING,
			payload: true
		});

		const {
			operators: {
				tableActivity: {
					columns,
					options: {
						filters: { filterUrlQuery },
						startIndex: startTableIndex,
						page
					},
					operator: { uuid }
				}
			}
		} = getState();

		const startIndex =
			options.page === page ? startTableIndex : options.startIndex;

		let url = `/activity/list?${filterUrlQuery}${queryParams(
			options,
			TABLE_LENGTH,
			columns,
			startIndex
		)}`;

		if (uuid) {
			url += `&operator_id=${uuid}`;
		}

		const { data } = await services.get(url);

		// Calculate pages
		const pages = Math.ceil(data.recordsFiltered / TABLE_LENGTH);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_ACTIVITIES_OPERATOR_SUCCESS,
			payload: { ...data, pages, page: options.page, startIndex }
		});

		// save request url in redux
		setRequestUrl(url)(dispatch);
	} catch (error) {
		dispatch({
			type: types.FETCH_ACTIVITIES_OPERATOR_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** SET SEARCH QUERY ********************
export const setActivityOperatorQuery = (query) => ({
	type: types.SET_ACTIVITY_OPERATOR_SEARCH_QUERY,
	payload: query
});

export const setActivityOperator = (uuid) => ({
	type: types.SET_ACTIVITY_OPERATOR,
	payload: { uuid }
});
